export const fetchArticles = async (isReadMoreFetch = false) => {

  const activeCategory = document.querySelector('[data-category].is--active') ? document.querySelector('[data-category].is--active').getAttribute('data-category') : false,
    articleListingRow = document.querySelector('[data-listing-next-page]'),
    nextPage = articleListingRow ? articleListingRow.getAttribute('data-listing-next-page') : false,
    loadMoreRow = document.querySelector('[data-load-more="row"]');

  let pathName = window.location.pathname.slice(-1) === '/' ? window.location.pathname.slice(0, -1).slice(0, -1) : window.location.pathname,
    fetchUrl = `${window.location.origin}${pathName}.json`,
    historyUrl = `${window.location.origin}${pathName}`,
    headers = {'X-Requested-With': 'fetch'}

  if (activeCategory) {
    fetchUrl = `${window.location.origin}${pathName}.json?filter=${activeCategory}`
    historyUrl = fetchUrl.replace('.json', '')
  }

  if (isReadMoreFetch) {
    fetchUrl = `${window.location.origin}${pathName}.json/page:${nextPage}`;
    historyUrl = `${window.location.origin}${pathName}?p=${nextPage}`;
    headers = {'X-Requested-With': 'fetch-more'}

    if (activeCategory) {
      fetchUrl = `${window.location.origin}${pathName}.json/page:${nextPage}?filter=${activeCategory}`
      historyUrl = `${window.location.origin}${pathName}?filter=${activeCategory}&p=${nextPage}`
    }
  }

  try {
    const response = await fetch(fetchUrl, {method: 'GET', headers: headers}),
      {html, more} = await response.json()

    if (html) {

      if (isReadMoreFetch) {
        const COUNT_UP_PAGE = parseInt(nextPage) + 1
        articleListingRow.setAttribute('data-listing-next-page', COUNT_UP_PAGE.toString())
        articleListingRow.insertAdjacentHTML('beforeend', html);

      } else {
        articleListingRow.setAttribute('data-listing-next-page', '2')
        articleListingRow.innerHTML = html
      }
    }

    if (more) loadMoreRow.classList.remove('d-none');
    else loadMoreRow.classList.add('d-none');

    window.history.replaceState({'html': html, 'pageTitle': response.pageTitle}, '', historyUrl)
    return true;

  } catch (error) {
    console.log('Fetching error: ', error)
  }
}
